import { useNavigate } from "react-router-dom";
import ReplayOutlinedIcon from "@mui/icons-material/ReplayOutlined";

/** Table ke upar: title + Wallet History → matching ledger page */
const WalletHistoryBar = ({ title, to, children }) => {
  const navigate = useNavigate();
  return (
    <div className="ds-card mb-3 mt-2 flex items-center justify-between gap-3 flex-wrap">
      <div className="min-w-0 flex-1">{children || (
        <h2 className="font-semibold text-[15px] text-[var(--text-dark)] m-0">{title}</h2>
      )}</div>
      <button
        type="button"
        className="ds-action-btn shrink-0"
        onClick={() => navigate(to)}
      >
        <ReplayOutlinedIcon fontSize="small" />
        <span className="hidden md:inline">Wallet History</span>
      </button>
    </div>
  );
};

export default WalletHistoryBar;
